import { jsx as _jsx } from "react/jsx-runtime";
import { Explore, LocationOn, Map } from "@mui/icons-material";
import { EmptyState } from "../../shared/EmptyState";
export const LocationEmptyState = ({ onAddLocation }) => {
    return (_jsx(EmptyState, { backgroundIcon: Map, primaryIcon: LocationOn, accentIcon: Explore, title: "Ready to Start?", description: "Get started by adding your first location. This will help you manage your organization's physical locations and their associated details.", action: onAddLocation
            ? { label: "Add Location", onClick: onAddLocation }
            : undefined }));
};
